export const SERVICE_CODE = 'LOCATION' + '_SERVICE';
